<template>
  <span class="badge" :style="badgeStyles">
    {{ title }}
  </span>
</template>

<script>
export default {
  name: 'Badge',
  props: {
    title: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: '#42b983' // Зеленый по умолчанию
    }
  },
  computed: {
    badgeStyles() {
      return {
        '--badge-color': this.color,
        '--text-color': this.getContrastColor(this.color)
      };
    }
  },
  methods: {
    // Метод для определения контрастного цвета текста (черный/белый)
    getContrastColor(hexColor) {
      const r = parseInt(hexColor.substr(1, 2), 16);
      const g = parseInt(hexColor.substr(3, 2), 16);
      const b = parseInt(hexColor.substr(5, 2), 16);
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      return luminance > 0.5 ? '#000' : '#fff';
    }
  }
};
</script>

<style scoped>
.badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.85em;
  font-weight: 600;
  background-color: var(--badge-color);
  color: var(--text-color);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.badge:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
}
</style>